import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const PlugIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M12 16a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1ZM9 1a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1Zm6 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M5 8a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5a5 5 0 0 1-5 5h-4a5 5 0 0 1-5-5V8Zm2 1v4a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3V9H7Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default PlugIcon;
